import { setPositions } from '@moleculeone/draw';
import { MoleculeConverter } from '@moleculeone/molecule-utils';
import { Mol } from '@moleculeone/types';

import { ConversionSmilesToMolError, ConversionMolToSmilesError } from '@f/error-decorators/errors/conversion';

import { calculateSeededPositions } from './mol';

const moleculeConverter = new MoleculeConverter({ ...wasm_bindgen });

export async function smilesToMol(smiles: string, params = {}) {
  try {
    const mol = await moleculeConverter.smilesToMol(smiles, params);
    return setPositions(
      mol,
      calculateSeededPositions({
        mol,
        seedId: smiles,
      })
    );
  } catch (error) {
    if (error instanceof Error) {
      console.error('Failed to convert SMILES to mol: %s', error.stack);
    }
    throw new ConversionSmilesToMolError({ errors: [error] });
  }
}

export async function molToSmiles(mol: Mol) {
  try {
    return moleculeConverter.molToSmiles(mol);
  } catch (error) {
    if (error instanceof Error) {
      console.error('Failed to convert mol to SMILES: %s', error.stack);
    }
    throw new ConversionMolToSmilesError({ errors: [error] });
  }
}
